import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
	root: {},
	bookingDuration: {
		marginTop: theme.spacing(3),
	},
}));
